// Team members for Smith Luxury Group, Miami.
// Demo names only — per CLAUDE.md, use Marco Rivera and Ana Castillo for the
// primary team_leader/agent archetypes. Never use real people's names.

export const ORG = {
  id: 'org-smith-luxury',
  name: 'Smith Luxury Group',
  brand: 'Smith Luxury | Miami',
  timezone: 'America/New_York',
};

export const agents = [
  {
    id: 'agent-marco-rivera',
    name: 'Marco Rivera',
    initials: 'MR',
    email: 'marco.rivera@smithluxury.demo',
    phone: '+1-305-555-0101',
    role: 'team_leader',
    title: 'Team Leader · Managing Broker',
    languages: ['English', 'Spanish'],
    specialties: ['Waterfront', 'Ultra-luxury', 'Miami Beach'],
    avatarColor: '#EA580C',
    stats: {
      activeLeads: 7,
      closingsYTD: 11,
      gciYTD: 1_420_000,
      avgResponseMinutes: 6,
    },
  },
  {
    id: 'agent-ana-castillo',
    name: 'Ana Castillo',
    initials: 'AC',
    email: 'ana.castillo@smithluxury.demo',
    phone: '+1-305-555-0102',
    role: 'agent',
    title: 'Senior Agent · New Construction',
    languages: ['English', 'Spanish', 'Portuguese'],
    specialties: ['New construction', 'International buyers', 'Brickell'],
    avatarColor: '#3b82f6',
    stats: {
      activeLeads: 9,
      closingsYTD: 8,
      gciYTD: 980_000,
      avgResponseMinutes: 8,
    },
  },
  {
    id: 'agent-diego-herrera',
    name: 'Diego Herrera',
    initials: 'DH',
    email: 'diego.herrera@smithluxury.demo',
    phone: '+1-305-555-0103',
    role: 'agent',
    title: 'Agent · Condo Specialist',
    languages: ['English', 'Spanish'],
    specialties: ['Brickell condos', 'Downtown', 'Investor buyers'],
    avatarColor: '#f59e0b',
    stats: {
      activeLeads: 8,
      closingsYTD: 6,
      gciYTD: 612_000,
      avgResponseMinutes: 11,
    },
  },
  {
    id: 'agent-natalia-ortiz',
    name: 'Natalia Ortiz',
    initials: 'NO',
    email: 'natalia.ortiz@smithluxury.demo',
    phone: '+1-305-555-0104',
    role: 'agent',
    title: 'Agent · Single Family',
    languages: ['English', 'Spanish'],
    specialties: ['Coral Gables', 'Pinecrest', 'Key Biscayne'],
    avatarColor: '#22c55e',
    stats: {
      activeLeads: 6,
      closingsYTD: 7,
      gciYTD: 845_000,
      avgResponseMinutes: 9,
    },
  },
  {
    id: 'agent-javier-pena',
    name: 'Javier Peña',
    initials: 'JP',
    email: 'javier.pena@smithluxury.demo',
    phone: '+1-305-555-0105',
    role: 'isa',
    title: 'ISA · Lead Qualification',
    languages: ['English', 'Spanish'],
    specialties: ['Inbound qualification', 'Discovery calls'],
    avatarColor: '#a855f7',
    stats: {
      leadsQualifiedMTD: 42,
      showingsBookedMTD: 14,
      avgResponseMinutes: 3,
    },
  },
  {
    id: 'agent-camila-reyes',
    name: 'Camila Reyes',
    initials: 'CR',
    email: 'camila.reyes@smithluxury.demo',
    phone: '+1-305-555-0106',
    role: 'isa',
    title: 'ISA · Follow-ups',
    languages: ['English', 'Spanish'],
    specialties: ['Nurture cadences', 'Reactivations'],
    avatarColor: '#ef4444',
    stats: {
      leadsQualifiedMTD: 28,
      showingsBookedMTD: 9,
      avgResponseMinutes: 4,
    },
  },
];

export const agentById = Object.fromEntries(agents.map((a) => [a.id, a]));

// Convenience lookups used by the UI layer.
export const TEAM_LEADER_ID = 'agent-marco-rivera';
export const CURRENT_DEMO_AGENT_ID = 'agent-ana-castillo';
